import type { LucideIcon, LucideProps } from "lucide-react";

import React from "react";

// Create the icon using the same pattern as lucide-react
const TextSpacing: LucideIcon = React.forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      color = "currentColor",
      size = 24,
      strokeWidth = 2,
      className = "",
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        stroke={color}
        className={className}
        {...props}
      >
        <path
          d="M7 5.875V4H17V5.875M10.125 14H13.875M12 4V9V14"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.6667 16L19 18M19 18L16.6667 20M19 18H5M5 18L7.33333 16M5 18L7.33333 20"
          strokeWidth={strokeWidth !== 2 ? strokeWidth : 1.5}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  },
);

// Add display name for React DevTools
TextSpacing.displayName = "TextSpacing";

export default TextSpacing;
